import { TagType, useResolution } from '@ecommerce/shared'
import React from 'react'
import { BlackTagText, FridayTagText, TagText, TagWrapper } from './styled'
import { BlackFridayIcon, CyberIcon, NewIcon, OutstandingIcon, TopSellingIcon } from './Icons'

interface TagProps {
  tag: string
  type?: string
  className?: string
  promo?: string
}

export const Tag = ({ tag, type, className, promo }: TagProps) => {
  const { isMobile } = useResolution()

  const NO_ICON_TAGS = ['promo', 'promotion', 'personalize_me']

  const tagValue = TagType[tag as keyof typeof TagType]

  const getIconSize = (): number => (isMobile ? 12 : 16)
  const iconSize = getIconSize()

  const getIcon = () => {
    switch (tagValue) {
      case TagType.new:
        return <NewIcon size={iconSize} />
      case TagType.cyber:
        return <CyberIcon size={iconSize} />
      case TagType.outstanding:
        return <OutstandingIcon size={iconSize} />
      case TagType.black_friday:
        return <BlackFridayIcon size={iconSize} />
      default:
        return <TopSellingIcon size={iconSize} />
    }
  }

  const getTitleTag = () => tagValue

  const blackFridayTag = () => {
    if (tag !== 'black_friday') return null
    const blackFridayText = tagValue.split(' ')
    return (
      <>
        <BlackTagText type={type}>{blackFridayText[0]}</BlackTagText>
        <FridayTagText type={type}>{blackFridayText[1]}</FridayTagText>
      </>
    )
  }

  const tagContent = promo || blackFridayTag() || getTitleTag()

  return (
    <TagWrapper className={className} type={type} tagType={tagValue}>
      {!NO_ICON_TAGS.includes(tag) && getIcon()}
      <TagText type={type}>{tagContent}</TagText>
    </TagWrapper>
  )
}
